import * as React from 'react'
import { FC, useCallback } from 'react'
import { IUserNotificationsSettingsDTO } from '@user/store/users/typings'
import { NotificationSettingFormFields } from './NotificationSettingFormFields'
import { Formik, FormikErrors } from 'formik'
import { useGetUserNotificationSettings } from '@user/store/users/hooks/useGetUserNotificationSettings'
import { SideDrawer } from '@sales-center/components'
import { UpdateUserNotificationSettings } from '@user/store/users/api'
import { useAppDispatch } from '@user/store/hooks'
import { toast } from '@sales-center/components'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

interface Props {
  onClose: () => void
  open: boolean
}

export const NotificationSettingsFormWrapper: FC<Props> = (props) => {
  const { onClose, open } = props

  const dispatch = useAppDispatch()

  const onSubmit = useCallback(
    async (model: IUserNotificationsSettingsDTO) => {
      const response = await dispatch(
        UpdateUserNotificationSettings({
          ...model,
          customEmails: model?.additional ?? [],
        }),
      )

      if (UpdateUserNotificationSettings.fulfilled.match(response)) {
        toast.success(`Notification Settings Saved.`)
        onClose()
      } else {
        toast.error(`Failed to save Notification Settings.`)
      }
    },
    [dispatch, onClose],
  )

  const { status, notificationSetting } = useGetUserNotificationSettings()

  const initialValues = {
    receiveAllNotificationsState:
      notificationSetting?.receiveAllNotificationsState ?? true,
    useDefaultNotificationMailState:
      notificationSetting?.useDefaultNotificationMailState ?? false,
    subscribeToMonthlySummaryEmails:
      notificationSetting?.subscribeToMonthlySummaryEmails ?? false,
    userId: notificationSetting?.userId ?? '',
    additional: notificationSetting?.useDefaultNotificationMailState
      ? []
      : notificationSetting?.customEmails ?? [],
  }

  const validate = useCallback((model: IUserNotificationsSettingsDTO) => {
    const errors: FormikErrors<IUserNotificationsSettingsDTO> = {}

    const { useDefaultNotificationMailState, additional } = model
    if (useDefaultNotificationMailState == false && additional?.length === 0) {
      errors.additional = 'Email is Required'
    }

    return errors
  }, [])

  return (
    <>
      <SideDrawer
        title={'NOTIFICATIONS'}
        open={open}
        onClose={onClose}
        width={550}
        disableBackdropClick={true}
      >
        {status === 'pending' && (
          <Box pt={4.8} textAlign="center">
            <CircularProgress />
          </Box>
        )}

        {status === 'success' && initialValues && (
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validate={validate}
          >
            <NotificationSettingFormFields onClose={onClose} />
          </Formik>
        )}
      </SideDrawer>
    </>
  )
}

NotificationSettingsFormWrapper.displayName = 'NotificationSettingsFormWrapper'
